import { useState, useEffect } from 'react';
import { FinanceService } from '../../../../core/services/FinanceService';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _Report } from '../../../../core/services/dataBean/EntityCatalog';
import { toast } from 'react-toastify';
import { PrintJson } from '../../../theme/Component/PrintJson';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}
export const SelectAvailableParsers = ({ idSelector, onChange, label }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_Report);
    const [id, setID] = useState(NaN);

    useEffect(() => {
        if (idSelector)
            setID(idSelector);
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: any) => {
        setID(e);
        onChange(e);
    }

    const getLista = () => {
        instance.getAvailableParsers(null).then(
            (resp) => {
                setLista(resp)
                if (resp.length === 1) {
                    setID(resp[0]);
                    onChange(resp[0]);
                }
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    return (
        <>
            <label>{label ?? "Tipo Parser"}</label>
            <select className="form-select" value={id} onChange={(e) => {
                const value = e.target.value ? (e.target.value) : null
                setValue(value)
            }}>
                <option value={""}>...</option>
                {lista &&
                    lista.map((item: any) => {
                        return (
                            <option key={item} value={item} >{item}</option>
                        )
                    })
                }
            </select>
        </>
    )
}